<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container-fluid wow fadeIn">
            <legend>Agent Growth Report</legend>

            <b-row>
                <b-col sm="6" md="2">
                    <b-form-group label-size="sm" label="Month 1:">
                        <b-form-select v-model="month1" :options="monthOptions" size="sm"></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="1">
                    <b-form-group label-size="sm" label="Year 1:">
                        <b-form-input v-model="year1" type="number" size="sm"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="2">
                    <b-form-group label-size="sm" label="Month 2:">
                        <b-form-select v-model="month2" :options="monthOptions" size="sm"></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="1">
                    <b-form-group label-size="sm" label="Year 2:">
                        <b-form-input v-model="year2" type="number" size="sm"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="2">
                    <b-form-group label-size="sm" label="Month 3:">
                        <b-form-select v-model="month3" :options="monthOptions" size="sm"></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="1">
                    <b-form-group label-size="sm" label="Year 3:">
                        <b-form-input v-model="year3" type="number" size="sm"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group label-size="sm" label="User ID:">
                        <b-form-input v-model="userId" type="text" size="sm" placeholder="Optional user ID"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-3">
                <b-col>
                    <b-button type="button" @click="getReport" pill variant="outline-dark">
                        Retrieve Report
                    </b-button>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <strong>Total Records: {{ totalRecords }}</strong>
                </b-col>
            </b-row>

            <div class="row pt-3">
                <div class="col">
                    <div class="table-responsive-md">
                    <b-table striped hover bordered small :items="items" :fields="fields" :tbody-tr-class="rowClass">
                    </b-table>
                    </div>
                    <br />
                    <b-pagination @input="handlePageClick" v-model="selectedPage" :total-rows="totalRecords"
                        :per-page="perPage" first-number last-number></b-pagination>
                </div>
            </div>

            <div class="vld-parent">
                <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
            </div>
        </div>
    </main>
</div>
